import { useEffect } from 'react';

export function useInitialCleanup() {
  useEffect(() => {
    const initial = document.getElementById('initial');
    initial?.remove();
  }, []);
}
